import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageMeta } from "@/components/PageMeta";
import { MatchDetailContent, useMatchDetail } from "@/components/MatchDetailDialog";

export default function MatchDetail() {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const { match, goals, loading, refresh } = useMatchDetail(id);
  const title = match ? `${match.home_team} – ${match.away_team}` : t("league.matchDetails");

  return (
    <div className="mx-auto w-full max-w-2xl px-4 py-6 space-y-4">
      <PageMeta
        title={`${title} | Tipomatic`}
        description={t("league.matchDetails")}
        path={`/match/${id ?? ""}`}
      />
      <Button asChild variant="ghost" size="sm" className="-ml-2">
        <Link to="/matches">
          <ChevronLeft className="h-4 w-4" />
          {t("common.back", "Zpět")}
        </Link>
      </Button>
      <MatchDetailContent match={match} goals={goals} loading={loading} onSynced={refresh} />
    </div>
  );
}
